import ArticleIcon from "@mui/icons-material/Article";
import AssessmentIcon from "@mui/icons-material/Assessment";
import NewspaperIcon from "@mui/icons-material/Newspaper";
import OpenInNew from "@mui/icons-material/OpenInNew";
import PostAddIcon from "@mui/icons-material/PostAdd";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import TodayIcon from "@mui/icons-material/Today";
import TopicIcon from "@mui/icons-material/Topic";
import WebIcon from "@mui/icons-material/Web";
import type { ItemType } from "core/entities";
import type { ReactNode } from "react";

const IconMap: Record<ItemType, ReactNode> = {
  Page: <WebIcon color="inherit" />,
  DmsDocument: <ArticleIcon color="inherit" />,
  DmsLibrary: <TopicIcon color="inherit" />,
  DmsDocNodeDocument: <ArticleIcon color="inherit" />,
  DmsDocNodeLibrary: <TopicIcon color="inherit" />,
  Event: <TodayIcon color="inherit" />,
  News: <NewspaperIcon color="inherit" />,
  External: <OpenInNew color="inherit" />,
  Extenso: <AssessmentIcon color="inherit" />,
  CMSKitPage: <WebIcon color="inherit" />,
  CMSKitBlogPost: <WebIcon color="inherit" />,
  Report: <AssessmentIcon color="inherit" />,
  EstimateRequest: <PostAddIcon color="inherit" />,
  PowerBiReport: <AssessmentIcon color="inherit" />,
  Unknown: <QuestionMarkIcon color="inherit" />,
};

export function MyLinksIcon({ itemType }: { itemType: ItemType }) {
  return <>{IconMap[itemType]}</>;
}
